import styled from "styled-components";

export const SingleInputLabel = styled.label`
  display: block;
  padding-left: 3px;
  width: 100%;
  text-align: left;
  color: #666666;
`;

export const SingleInputStyle = styled.input`
  margin-bottom: 2em;
  width: 100%;
  background: #fff;
  color: #333333;
  font: inherit;
  box-shadow: 0 6px 10px 0 rgb(0 0 0 / 10%);
  border: solid 1px #666666;
  border-radius: 5px;
  outline: 0;
  padding: 22px 18px;
`;

export const SingleInput = (props: any) => {
  const { placeholder, ...restProps } = props;

  return (
    <>
      <SingleInputLabel htmlFor={props.name ?? props.id}>
        {placeholder}:
      </SingleInputLabel>
      <SingleInputStyle {...restProps} />
    </>
  );
};
